import { daoPost } from 'mrf/Dao';
import { useFormDataSelector, useFormSelector } from 'mrf/redux/ReduxHelper';
import Button from 'mrf/view/Button';
import {FormContext, mrfErrorValidationHandler} from 'mrf/view/FormCRUD';
import { Col, Grid } from 'mrf/view/Grid';
import Paper from 'mrf/view/Paper';
import TextField from 'mrf/view/TextField';
import PageTitle from 'mrf/view/Title';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import notification, { TYPE } from 'mrf/utils/notification';
import IF from 'mrf/view/IF';
import mrf from 'mrf.config';
import T from 'mrf/utils/T';

export default function UpdatePasswordForm({ history }) {
    const query = new URLSearchParams(useLocation().search);

    const endpoint = '/api/users/updatePassword';

    const context = useFormSelector({
        resource: 'updatePassword',
        blankForm: o => ({ ...o, securityToken: query.get("token") }),
    });

    const data = useFormDataSelector(context);

    const [ title, setTitle ] = useState('');

    useEffect(() => {
        setTitle(JSON.parse(atob(query.get("token").split('.')?.[1]))?.title);
    }, []); // eslint-disable-line

    const backToLoginPage = () => {
        history.push('/');
    }

    const handleSubmit = async e => {
        try {
            e.preventDefault();

            const ret = await daoPost(endpoint, data);
            notification({ type: TYPE.DEFAULT, message: ret?.message });
            backToLoginPage();
        } catch (e) {
            mrfErrorValidationHandler(e, context);
            throw e;
        }
    }

    return <FormContext.Provider value={context}>
        <form onSubmit={handleSubmit}>
            <Paper>
                <Grid gap={4}>
                    <Col size={12}>
                        <PageTitle>{title}</PageTitle>
                    </Col>
                    <IF condition={!!mrf?.auth?.requirements}>
                        <Col size={12}>
                            <ul>
                                {mrf?.auth?.requirements?.split('\n').map(req => <li key={req}><T>{req}</T></li>)}
                            </ul>
                        </Col>
                    </IF>
                    <Col size={12}>
                        <TextField
                            type='password'
                            label='Password'
                            field='password'
                        />
                    </Col>
                    <Col size={12}>
                        <TextField
                            type='password'
                            label='Confirm Password'
                            field='confirmPassword'
                        />
                    </Col>

                    <Col size={6}>
                        <Button color='secondary' type='button' onClick={backToLoginPage}>Back</Button>
                    </Col>
                    <Col size={6}>
                        <Button color='primary' type='submit'>Save</Button>
                    </Col>
                </Grid>
            </Paper>
        </form>
    </FormContext.Provider>
}
